import { Injectable } from '@angular/core';

/** Service to interact with browser cookies */
@Injectable({ providedIn: 'root' })
export class ApCookieService {
    /** Fetch the value of a specific cookie. document.cookie contains key1=value1;key2=value2, this function returns the first hit */
    public get(name: string): string {
        const key = `${name}=`;
        return document.cookie
            .split(';') // split each cookie
            .map((cookie: string) => cookie.trim()) // trim whitespace
            .filter((cookie: string) => cookie.indexOf(key) === 0) // filter on key
            .map((cookie: string) => cookie.substring(key.length, cookie.length))[0]; // return first hit
    }

    /** Set a cookie, returns true when the cookie has been set. */
    public set(name: string, value: string, expiration?: string, domain?: string, path = '/', secure = false): boolean {
        if (!name) {
            return false;
        }
        let properties = '';
        if (expiration) {
            properties += `; expires=${expiration}`;
        }
        if (domain) {
            properties += `; domain=${domain}`;
        }
        if (path) {
            properties += `; path=${path}`;
        }
        if (secure) {
            properties += '; secure';
        }

        document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${properties}`;
        return true;
    }
}
